module.exports = __webpack_public_path__ + "static/media/message.f8240168.svg";